"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DEBUG_1 = require("@src/DEBUG");
const i0 = require("@angular/core");
const i1 = require("@angular/material/snack-bar");
const i2 = require("../../../projects/angular-sdk/src/4d-mapper.service");
DEBUG_1.DEBUG.open('/service/file-manager.ts');
const material_1 = require("@angular/material");
const Constants_1 = require("../commons/Constants");
const _4d_mapper_1 = require("4d-mapper");
const identify_interface_1 = require("../xs/interfaces/identify.interface");
// some files are potentially there
class VirtualDataset {
    constructor(incoming = null) {
        // workflow states
        this.isLoading = false;
        this.isParsing = false;
        this.isProcessing = false;
        // the actual source
        this.source = VirtualDataset.NONE;
        // references to a Dataset
        this.datasetId = null;
        this.datasetName = null;
        this.dataset = null;
        // our data
        this.raw = null;
        this.data = null;
        // most jobs deal with coordinates
        this.coords = null;
        // lots of jobs have workflows and states with them
        this.workflow = null;
        this.states = null;
        this.show = null;
        // ... and current state
        this.state = null;
        if (incoming) {
            this._inject(incoming);
        }
    }
    _inject(incoming = {}) {
        let me = this;
        Object.keys(incoming).forEach(key => {
            if (me.hasOwnProperty(key)) {
                me[key] = incoming[key];
            }
        });
    }
}
// sources
VirtualDataset.NONE = 'none';
exports.VirtualDataset = VirtualDataset;
class FileManagementService {
    constructor(snackBar, fourD) {
        this.snackBar = snackBar;
        this.fourD = fourD;
        this.__ID = null;
        this.debug = Constants_1.Constants.debug_off;
        this.debugMe = null;
        this.debugPrimary = Constants_1.Constants._green;
        this.debugSecondary = Constants_1.Constants._gray;
        DEBUG_1.DEBUG.log('/service/file-management.service.ts');
        this.__ID = identify_interface_1.XsIdentityInterface.__init(this);
    }
    findFiles(inputFilesEvent = null, maxFiles = null) {
        if (inputFilesEvent && inputFilesEvent.srcElement) {
            let files = inputFilesEvent.srcElement.files;
            if (this.debug) {
                console.log('%c fileManager %c findFiles()', this.debugPrimary, this.debugSecondary, inputFilesEvent, files);
            }
            return files;
        }
    }
    readFileFromBrowser(file = null) {
        if (!file) {
            return;
        }
        var reader = new FileReader();
        reader.readAsText(file);
        reader.onload = (data) => {
        };
    }
    getAttachments(item) {
        const me = this;
        return new Promise((resolve, error) => {
            let itemType = 'Annotation';
            if (item.id) {
                me.fourD.V.api('/api/' + itemType + '/' + item.id + '.files').subscribe(value => {
                    resolve(value);
                });
            }
        });
    }
    // attachFile ( 'some_file_name', item, byteStream )
    attachFile(filename = null, byteCharacters, item) {
        const me = this;
        let itemType = 'Annotation';
        const token = this.fourD.V.token;
        const host = this.fourD.V.config.host;
        if (!filename) {
            let d = new Date();
            filename = 'file_' + d.getTime();
        }
        var xhr = new XMLHttpRequest();
        var upload = xhr.upload;
        upload.addEventListener('progress', (evt) => {
            if (evt.lengthComputable) {
                /* self.progress = ((self.loaded + evt.loaded) / self.total);
                self.progressSubject.next(self.progress)*/
                // console.log(evt);
                // this.loadExistingAnnotation( '' + this.annotation.id ) ;
            }
        }, false);
        return new Promise((resolve, error) => {
            xhr.open('POST', host + '/api/' + itemType + '/' + item.id + '/' + filename);
            xhr.overrideMimeType('application/octet-stream');
            xhr.setRequestHeader('Content-Type', 'application/octet-stream');
            xhr.setRequestHeader('Authorization', 'Bearer ' + token);
            xhr.send(byteCharacters);
            xhr.onreadystatechange = () => {
                if (xhr.readyState === XMLHttpRequest.DONE) {
                    if (!xhr.responseText || xhr.responseText === '') {
                        me.snackBar.open(Constants_1.Constants.ERROR_MESSAGE, '', { duration: Constants_1.Constants.SNACKBAR_DURATION });
                        return;
                    }
                    // good response
                    var res = JSON.parse(xhr.responseText);
                    if (res.status && res.status === 200) {
                        {
                            resolve(res);
                            // me.snackBar.open(Constants.SUCCESS_MESSAGE, '', {duration: Constants.SNACKBAR_DURATION});
                            // this.openSnackBarSuccess(Constants.SUCCESS_MESSAGE);
                        }
                        // console.log('all good',res);
                        // this.getAttachedFiles();
                        // all good
                    }
                    else if (res.status && res.status < 400) {
                        // console.log('vasat error');
                        error(res);
                        // me.snackBar.open(Constants.ERROR_MESSAGE, '', {duration: Constants.SNACKBAR_DURATION});
                    }
                    else {
                        error(res);
                        // me.snackBar.open(Constants.ERROR_MESSAGE, '', {duration: Constants.SNACKBAR_DURATION});
                    }
                }
            };
        });
    }
    /* Older code from various places; all of these are to be replaced over time */
    isCSVFile(file) {
        return file.name.endsWith(".csv");
    }
    getHeaderArray(csvRecordsArr, tokenDelimeter) {
        if (csvRecordsArr[0].endsWith(','))
            csvRecordsArr[0] = csvRecordsArr[0].substr(0, csvRecordsArr[0].length - 1);
        let headers = csvRecordsArr[0].split(tokenDelimeter);
        if (!headers || headers.length <= 1) {
            headers = csvRecordsArr[0].split('\t');
        }
        let headerArray = [];
        for (let j = 0; j < headers.length; j++) {
            headerArray.push(headers[j]);
        }
        return headerArray;
    }
    validateHeaders(origHeaders, fileHeaaders) {
        if (origHeaders.length != fileHeaaders.length) {
            return false;
        }
        var fileHeaderMatchFlag = true;
        for (let j = 0; j < origHeaders.length; j++) {
            if (origHeaders[j] != fileHeaaders[j]) {
                fileHeaderMatchFlag = false;
                break;
            }
        }
        return fileHeaderMatchFlag;
    }
    getDataRecordsArrayFromCSVFile(csvRecordsArray, headerLength, validateHeaderAndRecordLengthFlag, tokenDelimeter, DEFAULT_LATITUDE_ACCURACY, DEFAULT_LONGITUDE_ACCURACY, DEFAULT_HEIGHT_ACCURACY) {
        var dataArr = [];
        for (let i = 0; i < csvRecordsArray.length; i++) {
            if (csvRecordsArray[i].endsWith(','))
                csvRecordsArray[i] = csvRecordsArray[i].substr(0, csvRecordsArray[i].length - 1);
            let data = csvRecordsArray[i].split(tokenDelimeter);
            if (!data || data.length <= 1) {
                data = csvRecordsArray[i].split('\t');
            }
            if (validateHeaderAndRecordLengthFlag && data.length != headerLength) {
                if (data == "") {
                    // alert("Extra blank line is present at line number "+i+", please remove it.");
                    continue;
                }
                else {
                    this.snackBar.open("Record at line number " + i + " contain " + data.length + " tokens, and is not matching with header length of :" + headerLength, '', { duration: Constants_1.Constants.SNACKBAR_DURATION });
                    continue;
                }
            }
            let col = [];
            for (let j = 0; j < data.length; j++) {
                col.push(data[j].trim());
            }
            if (col.length !== 7) {
                col.push(DEFAULT_LATITUDE_ACCURACY);
                col.push(DEFAULT_LONGITUDE_ACCURACY);
                col.push(DEFAULT_HEIGHT_ACCURACY);
            }
            dataArr.push(col);
        }
        return dataArr;
    }
}
FileManagementService.tokenDelimeter = ",";
FileManagementService.isHeaderPresentFlag = true;
FileManagementService.validateHeaderAndRecordLengthFlag = true;
FileManagementService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FileManagementService_Factory() { return new FileManagementService(i0.ɵɵinject(i1.MatSnackBar), i0.ɵɵinject(i2.FourDService)); }, token: FileManagementService, providedIn: "root" });
exports.FileManagementService = FileManagementService;
